<template>
  <div>

    <loading :loading="loading"></loading>

    <error-alert-item
        :error-alert-event="errorAlertEvent"
        :network-error="networkError"
        @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <table class="w100 margin-top-10" v-if="showSearchBar">
      <tr>
        <td class="padding-left-10">
          <!--SearhBar Componet start-->
          <search-bar
              :InputPlaceHolderText="searchBarInputPlaceHolder"
              @searchedQuery="onSearchClicked"
          ></search-bar>
          <!--SearhBar Componet end-->
        </td>
      </tr>
    </table>

    <weex-text
        class="item-sm-heading border-bottom margin-top-10 margin-left-20 margin-right-20"
        v-if="heading"
        v-html="heading"
    ></weex-text>


    <div v-show="showLoans" class="margin-top-20">
      <div v-for="(ezLoan, index) in ezLoans" :key="index">
        <loan-item
            class="margin-top-10 margin-bottom-10 margin-left-20 margin-right-20 background-color-white"
            :ez-loan="ezLoan"
            @onLoanSelected="openLoan"
        ></loan-item>
      </div>

      <table class="w100 margin-top-10 margin-bottom-20" v-if="showPagination">
        <tr class="text-align-center">
          <td>
            <paginate
                :page-range="1"
                :pageCount="paginationPageCount"
                :containerClass="'pagination'"
                :clickHandler="onPageNumberSelected"
            ></paginate>
          </td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import Loading from "../layout/Loading";
import LoanItem from "../layout/LoanItem";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import RedirectingMessageDialog from "../dialogs/RedirectingMessageDialog";
import ActivityNavigator, { Activities, } from "../../utils/ActivityNavigator";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import DataSource from "../../data/DataSource";
import EzUtils from "../../utils/EzUtils";
import PrefManager from "../../data/model/PrefManager";
import { RolesConstants } from "../../utils/RolesConstants";
import { LoanStatus } from "../../utils/LoanStatusDetails";
import SearchBar from "../layout/SearchBar";
import { Constants } from "../Constants";
import Paginate from 'vuejs-paginate';
import AddButtonDialog from "@/components/dialogs/AddButtonDialog";

export default {
  name: "HomeLoansProvider",
  components: {
    ErrorAlertItem,
    LoanItem,
    Loading,
    WxcButton,
    RedirectingMessageDialog,
    SearchBar,
    AddButtonDialog,
    Paginate
  },
  data: () => ({
    showLoans: false,
    ezLoans: [],
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    searchBarInputPlaceHolder: "Search here..",
    currentPageNumber: 1,
    loanOffset: 0,

    heading: null,
    forShowingMainLoans: false,
    associatedEntities : null,
    showPagination: false,
    showSearchBar: false
  }),
  methods: {

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    openLoan(ezLoan) {
      LoanScopeDataHolder.setDetailsFromEzLoan(ezLoan);
      ActivityNavigator.navigateTo(Activities.LOAN_DETAILS);
    },

    onApplyNewLoan() {
      LoanScopeDataHolder.clearLoanScopeData();
      ActivityNavigator.navigateTo(Activities.CUSTOMER_PHONE_NUMBER);
    },

    isLoanRejected(ezLoan) {
      return EzUtils.areEqualString(LoanStatus.REJECTED, this.getLoanStatus(ezLoan), true);
    },

    getLoanStatus(ezLoan) {
      if (ezLoan && ezLoan.loan && ezLoan.loan.status
          && ezLoan.loan.status.value) {
        return ezLoan.loan.status.value;
      }
      return "";
    },

    fetchLoansExternalMethod(heading, forShowingMainLoans, associatedEntities) {
      this.heading = heading;
      this.forShowingMainLoans = forShowingMainLoans;
      this.associatedEntities = associatedEntities;
      this.showSearchBar = forShowingMainLoans;

      this.fetchLoans();
    },

    onSearchClicked(query) {
      if (query && query.trim()) {
        this.loading = true;
        const resource = Constants.CLIENTS + "," + Constants.LOANS;
        DataSource.getLoanByResources(query.trim(), resource, true)
        .then(loansData => {
          this.loading = false;
          if (loansData.errorOccurred) {
            this.showError(loansData.data);
          } else {
            this.ezLoans = loansData.data;
          }
        });
      } else {
        this.fetchLoans();
      }
    },

    onPageNumberSelected(pageNumber) {
      this.currentPageNumber = pageNumber;
      this.fetchLoansForPageNo(pageNumber);
    },

    fetchLoansForPageNo(pageNumber) {
      if (pageNumber > 0) {
        this.loanOffset = (pageNumber - 1) * 10;
        this.ezLoans = [];
        this.fetchLoans();
      }
    },

    fetchLoans() {
      this.showPagination = false;

      if (!this.forShowingMainLoans) {
        this.loading = true;
        this.getLoansByAssociatedEntities()
        .then(ezLoanRes => {
          this.loading = false;
          if (ezLoanRes.errorOccurred) {
            this.showError(ezLoanRes.data)
          } else {
            this.ezLoans = ezLoanRes.data;
            this.showLoans = true;
          }
        })
      } else {
        this.loading = true;
        const offset = this.isAgent ? this.loanOffset : null;
        const limit = this.isAgent ? 10 : null;
        const officeId = this.isAgent ? PrefManager.getUserOfficeId() : null;
        const staffConfig = PrefManager.getStaffConfig();
        const staffId = staffConfig && EzUtils.isTrue(staffConfig.is_self_staff)
            ? PrefManager.getStaffId() : null;
        DataSource.getLoansForStages(offset, limit, null, null, "id", "DESC", staffId, officeId, Constants.LOAN_APPLICACTION_TYPE_MAIN)
        .then(loansData => {
          this.loading = false;
          this.showPagination = this.isAgent;
          if (loansData.errorOccurred) {
            this.showError(loansData.data);
          } else {
            this.ezLoans = loansData.data;
            this.showLoans = true;
          }
        })
      }
    },

    getLoansByAssociatedEntities() {
      return new Promise(resolve => {
        const returnResponse = [];

        if (EzUtils.isNotEmpty(this.associatedEntities)) {
          const noOfAssociatedEntities = this.associatedEntities.length;
          let index = 0;
          while (index++ < noOfAssociatedEntities) {
            returnResponse.push({});
          }
          let addedAssociatedEntityLoans = 0;
          this.associatedEntities.forEach((associatedEntity, index) => {
            if (EzUtils.isValidId(associatedEntity["associated_loan_id"])) {
              DataSource.getEzLoanById(associatedEntity["associated_loan_id"])
              .then(ezLoanRes => {
                let ezLoan = null;
                if (!ezLoanRes.errorOccurred) {
                  ezLoan = ezLoanRes.data;
                }
                returnResponse.splice(
                    index,
                    1,
                    { associatedEntity: associatedEntity, ezLoan: ezLoan }
                );

                addedAssociatedEntityLoans++;
                if (addedAssociatedEntityLoans === noOfAssociatedEntities) {
                  resolve(DataSource.onResponse(returnResponse));
                }
              })
            } else {
              returnResponse.splice(
                  index,
                  1,
                  { associatedEntity: associatedEntity, ezLoan: null }
              );
              addedAssociatedEntityLoans++;
              if (addedAssociatedEntityLoans === noOfAssociatedEntities) {
                resolve(DataSource.onResponse(returnResponse));
              }
            }
          })
        } else {
          resolve(DataSource.onResponse(returnResponse));
        }
      })
    }
  },

  computed: {
    isAgent() {
      return PrefManager.doesUserHasRole(RolesConstants.AGENT);
    },

    paginationPageCount() {
      return this.currentPageNumber + 5;
    },

    applyNewLoanButtonStyle() {
      return { width: "120px" };
    },
  },
};
</script>

<style src="../../assets/style/base.css"></style>
